angular.module('rckd.utils', []);